import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 登入檢查
 */
const LoginPostBack = (data: any): Promise<GeneralResp> => {
    const url = RouteUrlList.API_LoginPostBack.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<GeneralResp>) => {
        return res.data;
    });
};

export default LoginPostBack;
